module.exports = __webpack_public_path__ + "img/maj2.9c12ff5a.jpg";